module.exports = "<div class=\"page-layout blank p-24\" fusePerfectScrollbar>\r\n\r\n    <h2>{{'SAMPLE.HELLO' | translate}}</h2>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/sample/sample.component.html
// module id = ./src/app/main/content/sample/sample.component.html
// module chunks = main